import type { CategorieDossier } from '@repere/core';
import { Picto } from './Picto';

/**
 * Un bloc vide — « aucune dépense pour l'instant », « aucun message ».
 *
 * C'est le seul endroit de l'application où le pictogramme passe en pastel et en grand.
 * Le rapport de contraste y tombe à 1,3:1 sur blanc, ce qui serait inacceptable pour une
 * icône porteuse de sens : ici le dessin ne dit rien que la phrase ne dise déjà, il occupe
 * le vide. C'est aussi pour cela qu'il est purement décoratif — `Picto` est `aria-hidden`,
 * et un lecteur d'écran n'entend que la phrase.
 *
 * **Un bloc vide n'est pas une consigne.** « Aucune dépense pour l'instant » constate ;
 * « Ajoutez votre première dépense » commanderait, et le produit ne commande pas à des
 * parents qui n'ont pas choisi d'être là (docs/01 §5.5). Le texte reste au constat, et
 * « pour l'instant » dit que le vide est un état, pas un retard.
 */
export function Vide({
  categorie,
  children,
}: {
  categorie: CategorieDossier;
  children: React.ReactNode;
}) {
  return (
    <div className="bloc-vide">
      <span className="bloc-vide-picto">
        <Picto categorie={categorie} taille={64} />
      </span>
      <p className="discret">{children}</p>
    </div>
  );
}
